import { useContext, useRef, useState } from "react";
import DynamicForm from "../../../components/DynamicForm/DynamicForm";
import { UserContext } from "../../../context/UserContext";

import { text_validation, email_validation, UseValidation, phone_validation } from "../../../components/DynamicForm/Helpers/validationMethods";
import { GetSubscriptionPrice, GetSubscriptionTier } from "../../../utils/businessUtils";
import { SettingOption } from "../../../components/SettingOption/setting-option";
import "./subscription-settings.css";
import { Alert, formatDateForDatePicker } from "../../../utils/genericUtils";
import { AlertContext } from "../../../context/AlertContext";
import { LoaderContext } from "../../../context/LoaderContext";
import { GET, POST } from "../../../utils/httpUtils";
import { NotificationsContext } from "../../../context/NotificationsContext";

import checkIcon from "../../../assets/images/greenCheck.png";
import errorIcon from "../../../assets/images/error.png";
import { useNavigate } from "react-router-dom";
import { ConfirmationModal } from "../../../components/Modals/ConfirmationModal/confirmation-modal";
import ProdIgnore from "../../../components/ProductionIgnore/prod-ignore";

const defaultProps = {
  onChanged: () => {},
};

export default function SubscriptionSettings(props = defaultProps) {
  const router = useNavigate();

  const { user, loginUser } = useContext(UserContext);

  const { show, showloader, hideloader } = useContext(LoaderContext);
  const { globalAlert } = useContext(AlertContext);

  const { pushNotification } = useContext(NotificationsContext);

  const [showCancelModal, setShowCancelModal] = useState(false);

  const valid = useRef(new Map());

  UseValidation(valid);

  const isValid = () => ![...valid.current.values()].some((v) => v === false);

  const SubscriptionSettingsFields = [
    {
      id: "subscription-plan",
      name: "Subscription Plan",
      type: "text",
      disabled: true,
      value: GetSubscriptionTier(user.subscription).toUpperCase(),
    },
    {
      id: "subscription-cost",
      name: "Monthly Price",
      type: "text",
      disabled: true,
      value: GetSubscriptionPrice(user.subscription),
    },
    {
      id: "last-payment-plan",
      name: "Last Invoice",
      type: "date",
      disabled: true,
      value: formatDateForDatePicker(user.lastPaymentDate),
    },
    {
      id: "next-payment-plan",
      name: "Next Invoice",
      type: "date",
      disabled: true,
      value: formatDateForDatePicker(user.nextBillingDate),
    },
  ];

  function onCancelClick() {
    setShowCancelModal(true);
  }

  async function CancelSubscription() {
    showloader();
    setShowCancelModal(false);
    let delete_response = await POST("/cancel-subscription", undefined, user);
    hideloader();
    if (delete_response.success) {
      Alert(
        globalAlert,
        "success",
        "Subscription Canceled",
        "Your subscription has been successfully canceled. You can re-subscribe at any time.",
        () => {
          window.location.reload();
        },
        "Refresh"
      );
    } else {
      Alert(globalAlert, "error", "Something went wrong", delete_response.error.message);
    }
  }

  async function SeeTransactionHistory() {
    showloader();
    let session_response = await GET("/stripe-transaction-history", user);
    hideloader();
    if (session_response.success) {
      window.location.href = session_response.url;
    } else {
      Alert(globalAlert, "error", "Something went wrong", session_response.error.message);
    }
  }

  return (
    <section className="subscription-settings-container">
      {user.subscription > 0 && (
        <>
          {/* Account Standing Graphic */}
          <div className="account-standing-conatiner">
            <label htmlFor="">Account In Good Standing?</label>
            <span>
              {user.isInGoodStanding === true ? "Yes" : "No"}
              <img
                className="account-standing-graphic"
                src={user.isInGoodStanding === true ? checkIcon : errorIcon}
                alt={user.isInGoodStanding === true ? "Account in good standing!" : "Account not in good standing!"}
              />
            </span>
          </div>
          {/* NIGO message */}
          {user.isInGoodStanding === false && (
            <p className="nigo-message">
              *We couldn’t process your last payment. Please review your billing information before your account is reverted to the free tier.
            </p>
          )}
          <div className="setting-option-divider"></div>
        </>
      )}

      <div className="subscription-settings-form-container">
        <DynamicForm id={"subscription-settings-form"} layout={[2, 2]} fields={SubscriptionSettingsFields} />
      </div>

      <h3>Actions</h3>
      <div className="setting-option-divider"></div>

      <SettingOption
        id={"manage-billing"}
        controlType={"button"}
        buttonText="Billing Info"
        description="Manage your billing details, view invoices, and update your payment methods securely through Stripe."
        onClick={SeeTransactionHistory}
        showDivider={true}
      />

      <SettingOption
        id={"manage-billing"}
        controlType={"button"}
        buttonText="Change Plan"
        description="Upgrade or downgrade your subscription tier.
To switch to the Free tier, please use the Cancel Subscription button instead."
        onClick={() => router("/change-plan")}
        showDivider={true}
      />

      {user.subscription > 0 && (
        <>
          <ConfirmationModal
            id="subscription-cancel-modal"
            isActive={showCancelModal}
            showDivider={true}
            animate={true}
            header="Are You Sure?"
            message={`Canceling your active subscription will immediately remove access to all premium features.
            Any files exceeding the 5GB Free tier limit will be automatically moved to your Trash, starting with the most recently uploaded files.`}
            onClickOut={() => setShowCancelModal(false)}
            onDeny={() => setShowCancelModal(false)}
            includeCheckboxSafety={true}
            safetyText="I understand the consequence of this action."
            confirmText="Cancel Subscription"
            denyText="Keep Subscription Active"
            onConfirm={CancelSubscription}
          />
          <SettingOption
            id={"manage-billing"}
            controlType={"button"}
            buttonText="Cancel Subscription"
            buttonClass={"btn-red-inverted"}
            description="Canceling your active subscription will immediately remove access to all premium features.
            Any files exceeding the 5GB Free tier limit will be automatically moved to your Trash, starting with the most recently uploaded files."
            onClick={onCancelClick}
            showDivider={false}
          />
        </>
      )}
    </section>
  );
}
